import request from '../index'

//获取产品详情
export function getProductDetails(id) {
	return request({
		url: '/product/info' + '?id=' + id,
		method: 'get',
	})
}
